import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  hero : {
    backgroundImage: props => `url('${props.configs["marketplaceHeroBgImageUrl"]}')`,
    minHeight: '350px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  }
});

const MarketplaceHero = (props) => {
  const classes = useStyles(props);
  const translations = props.translations.data;
  const configs = props.configs;
  let ctas = [];
  let index = 1;
  if (!props.hideCTA) {
    while(translations[`MARKETPLACE.HERO.CTA.${index}`]) {
      const url = configs[`marketplaceHeroCta${index}Url`];
      const label = translations[`MARKETPLACE.HERO.CTA.${index}`];
      index++;
      if (!url || !label) {
        continue;
      }
      ctas.push({label: label, url: url});
    }
  }

  return (
    <div className={`${classes.hero} marketplace-hero`}>
      <div className="content-wrapper">
        <div className="title">
          {translations["MARKETPLACE.HERO.TITLE"]}
        </div>
        <div className="description">
        {translations["MARKETPLACE.HERO.DESCRIPTION"]}
        </div>
        {
          ctas.length > 0 && <div className="cta-wrapper">
            { ctas.map((item, index) => (
              <button key={index} className="cta" onClick={()=>props.handleCTAClick(item.url)}>{item.label}</button>
            ))}
          </div>
        }
      </div>
    </div>
  );
};

export default MarketplaceHero;
